import React, {useEffect, useState} from 'react';
import {handleClickLinks} from '../includes/utils';
import PropTypes from "prop-types";

export function CsfFournisseurListFormateursTable({trainersList, urlFormationDetailList}) {

  return (
    <div className="table-wrapper">
      <table id="formateur-list-table">
        <caption id="formateur-list-caption" className="sr-only">{window.Drupal.t('fournisseur.trainers.listing.page.title')}</caption>
        <thead>
        <tr>
          <th width="20%">{window.Drupal.t('fournisseur.trainers.listing.table.name')}</th>
          <th>{window.Drupal.t('fournisseur.trainers.listing.table.nb')}</th>
          <th width="90"></th>
        </tr>
        </thead>
        <tbody>

        {trainersList.length === 0 ? (
            <tr>
              <td colSpan="6">
                <p>{window.Drupal.t('fournisseur.empty.training.list')}</p>
              </td>
            </tr>
        ) : (
          trainersList.map((item) => (
            <tr key={item.CSF_EP_List_Id}>
              <td>{item.List_Name}</td>
              <td>
                {(item.Nb_Formateurs !== null && item.Nb_Formateurs !== undefined) && (
                  item.Nb_Formateurs + ' ' + window.Drupal.t('fournisseur.modal.btn.formateur') +
                  (item.Nb_Formateurs > 1 ? 's' : '')
                )}
              </td>
              <td>
                <button type="button" className='button btn-outlined' aria-label={`${window.Drupal.t('fournisseur.open.btn.label')} ${item.List_Name}`} onClick={() => handleClickLinks(urlFormationDetailList, 'list', item.CSF_EP_List_Id)} title={window.Drupal.t('fournisseur.open.btn.label')}>
                  {window.Drupal.t('fournisseur.open.btn.label')}
                </button>
              </td>
            </tr>
          )))}
        </tbody>
      </table>
    </div>
  );
}

CsfFournisseurListFormateursTable.propTypes = {
  trainersList: PropTypes.array,
  urlFormationDetailList: PropTypes.string,
};
